import { FIREBASE_TOKEN_COOKIE } from 'config/cookie';
import { cookiesInstance } from './cookiesInstance';

export const set = (value: string) => cookiesInstance.set(FIREBASE_TOKEN_COOKIE, value);

export const get = () => {
  const firebaseToken = cookiesInstance.get(FIREBASE_TOKEN_COOKIE);
  return firebaseToken;
};

export const remove = () => cookiesInstance.remove(FIREBASE_TOKEN_COOKIE);
